import {Component, forwardRef, OnInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Subscription} from 'rxjs';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {delay, distinctUntilChanged, tap} from 'rxjs/operators';
import { compareMatch, OriginatorRelationshipValue, OriginatorRelationshipValueOptions } from '@portal-workspace/grow-shared-library';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';



@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'originator-relationship',
    templateUrl: './originator-relationship.component.html',
    styleUrls: ['./originator-relationship.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => OriginatorRelationshipComponent), multi: true },
    ],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatOptionModule]
})
export class OriginatorRelationshipComponent extends AbstractControlValueAccessor<OriginatorRelationshipValue> implements  OnInit {

  options = OriginatorRelationshipValueOptions;

  subscriptions: Subscription[] = [];

  formControl: FormControl<OriginatorRelationshipValue>;


  constructor(private formBuilder: FormBuilder) {
    super();
    this.formControl = formBuilder.control(null, [Validators.required]);
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
    const sub = this.formControl.valueChanges.pipe(
      delay(0),
      distinctUntilChanged(compareMatch),
      tap((r: OriginatorRelationshipValue) => {
        if (this.formControl.valid) {
          this.propagateChange(r);
        } else {
          this.propagateChange(null);
        }
      })
    ).subscribe();
    this.subscriptions.push(sub);
  }

  doWriteValue(v: OriginatorRelationshipValue | undefined): void | OriginatorRelationshipValue {
    if (v) {
      this.formControl.setValue(v);
    }
    return undefined;
  }
}
